
























import { Component, Prop, Vue} from 'vue-property-decorator';
import { KNOWLEDGE_CHECK_EVENTS } from '@/author/constants';
import KnowledgeCheckEvents from '@/author/components/KnowledgeCheckParts/KnowledgeCheckEvents.vue'

@Component
export default class QuizOption extends Vue {
  @Prop() type?: string;
  @Prop() src?: string;
  @Prop() alt?: string;
  @Prop() right?: boolean;
  @Prop() modal?: boolean;

  correctFeedback!: string;
  incorrectFeedback!: string;
  selectedFeedback!: string;
  instantFeedback!: boolean;
  showFeedback!: boolean;
  multiple: boolean = false;

  selected: boolean = false;
  answer: boolean = false;
  id: string = '';

  created(){
    // this.$parent.$on(KNOWLEDGE_CHECK_EVENTS.MOUNTED, (multiple:boolean)=>{
    //   this.multiple = multiple
    // });
    KnowledgeCheckEvents.$on(KNOWLEDGE_CHECK_EVENTS.AFTER_OPTION_MOUNTED, (multiple:boolean)=>{
      this.multiple = multiple
    });

    KnowledgeCheckEvents.$on(KNOWLEDGE_CHECK_EVENTS.CLEAR_OPTIONS,() => {
      this.heandleClearOptions();
    });

    let parent : any = this.$parent
    this.correctFeedback = parent.accessibilityCorrectFeedback;
    this.incorrectFeedback = parent.accessibilityIncorrectFeedback;
    this.selectedFeedback = parent.accessibilitySelectedFeedback;
    this.instantFeedback = parent.instantFeedback;
    this.showFeedback = parent.showFeedback;
    KnowledgeCheckEvents.$emit(KNOWLEDGE_CHECK_EVENTS.OPTION_MOUNTED, this);
  }

  mounted() {
    this.answer = this.right !== undefined;
    this.id = (this as any)._uid;
    if(this.instantFeedback){
      this.showFeedback = true
    }
    KnowledgeCheckEvents.$on(KNOWLEDGE_CHECK_EVENTS.CLEAR_OPTIONS,() => {
      this.heandleClearOptions();
    });
  }

  beforeDestroy(){
    KnowledgeCheckEvents.$off([KNOWLEDGE_CHECK_EVENTS.CLEAR_OPTIONS,KNOWLEDGE_CHECK_EVENTS.AFTER_OPTION_MOUNTED])

  }
  handleQuizOptionClick() {
    if(!this.multiple){
      KnowledgeCheckEvents.$emit(KNOWLEDGE_CHECK_EVENTS.CLEAR_OPTIONS, this);
      this.selected = true
    }else{
      this.selected = !this.selected;
    }
    KnowledgeCheckEvents.$emit(KNOWLEDGE_CHECK_EVENTS.OPTION_SELECTED, this);
  }
  heandleClearOptions() {
    this.selected = false;
  }
  get hasCustomFeedback():boolean{
    return !!this.$slots['feedback']
  }

  get slot_id(){
    return `id_${this.id}_slot`
  }

}
